import React from 'react';
import { SidebarType } from 'app/models';
import SidebarContent from './SidebarContent';

interface Props {
  type: SidebarType;
}
const Sidebar = ({ type }: Props) => {
  return (
    <React.Fragment>
      <div className="vertical-menu">
        <div data-simplebar className="h-100">
          {type !== 'condensed' ? <SidebarContent /> : <SidebarContent />}
        </div>
      </div>
    </React.Fragment>
  );
};

export default Sidebar;
